<template>
  <v-container fluid fill-height justify-center id="scrolling-techniques-7" class="overflow-y-auto px-4" key="dashboard">
    <transition name="router-anim" mode="out-in">
      <v-row v-if="params" key="data-present" class="pb-9 mb-9 max-w">
        <v-col cols="12" class="pb-0">
          <boiler-card :loading="loading" :moduleName="moduleName" :controllerId="controllerId" :permission="permission" ></boiler-card>
        </v-col>
        <v-col cols="12" class="pb-0">
          <cw-card :loading="loading" :moduleName="moduleName" :controllerId="controllerId" :permission="permission"></cw-card>
        </v-col>
        <v-col cols="12" v-if="isValvePresent" class="pb-0">
          <valve-card :loading="loading" :moduleName="moduleName" :controllerId="controllerId" :permission="permission"></valve-card>
        </v-col>
      </v-row>
      <v-row v-else key="no-data">
        <v-col cols="12" class="text-center">
          <!--<v-progress-circular
            :width="5"
            :size="80"
            color="primary"
            indeterminate
          ></v-progress-circular>-->
        </v-col>
      </v-row>
    </transition>
  </v-container>
</template>

<script>
import controller from '@/store/modules/controller';
import BoilerCard from './../components/BoilerCard.vue'
import CwCard from './../components/CwCard.vue'
import ValveCard from './../components/ValveCard.vue'
import { mapActions, mapGetters } from 'vuex'
import RegisterStoreModule from '@/mixins/RegisterStoreModule'

export default {
  data: () => ({
    
  }),
  computed: {
    ...mapGetters([
      'controllerById',
    ]),
    controllerId() {
      return this.$route.params.controllerId;
    },
    moduleName() {
      return 'c' + this.controllerId;
    },
    controller() {
      return this.controllerById(this.controllerId)
    },
    params() {
      return (this.$store.state[this.moduleName]) ? this.$store.state[this.moduleName].params : undefined
    },
    permission() {
      if (typeof this.$store.state[this.moduleName] === 'object' && typeof this.$store.state[this.moduleName] !== null) {
        return (typeof this.$store.state[this.moduleName].params === 'object' && this.$store.state[this.moduleName].params !== null) ? this.$store.state[this.moduleName].params.permission : undefined
      } else {
        return undefined
      }
    },
    isValvePresent() {
      return (this.params.valveTemp) ? true : false
    },
    loading() {
      if (this.$store.state[this.moduleName] !== undefined) {
        return this.$store.state[this.moduleName].loading
      } else {
        return true
      }
    }
  },
  mixins: [ RegisterStoreModule ],
  created () {
    
    if (typeof this.controllerById(this.controllerId) === 'undefined') {
      this.$router.push({ path: '/controllers' });
    } else {
      this.registerStoreModule(this.moduleName, controller);
      this.syncController(false)
      .then(res => {
        return this.$store.dispatch(`notifications/getNotifications`, { controllerId: null, forced: false })
      });
      //this.$store.dispatch('setRecent', this.controllerId); //ostatnio odwiedzony sterownik
    }
  },
  methods: {
    syncController(forced) {
      return this.$store.dispatch(`${this.moduleName}/syncController`, forced)
    },
    refresh() {
      this.loading = true;
      this.syncController(true)
      .then(res => {
        this.loading = false;
      });
    },
    bck() {
      this.$router.push({ path: '/controllers' });
    }
  },
  components: {
    BoilerCard, CwCard, ValveCard
  }
}
//https://codeburst.io/dynamic-modules-with-vuex-and-vue-b9c481ca792
</script>

